import { useField } from "formik";
import { FC } from "react";
import { ContactUpdateInquiryAttributeDiffRowResource } from "../../../../shared/types/contactUpdateInquiry";
import { ContactUpdateAttributeDiffCard } from "./ContactUpdateAttributeDiffCard";
import { ContactUpdateFormValue } from "./contactUpdateTypes";
import { attributeDiffEntryToIdentifier } from "./contactUpdateUtils";

interface Props {
	row: ContactUpdateInquiryAttributeDiffRowResource;
}

export const ContactUpdateAttributeDiffRow: FC<Props> = ({ row }) => {
	const name = `attributes.${attributeDiffEntryToIdentifier(row.currentContact)}`;
	const [field] = useField<ContactUpdateFormValue>(name);

	return (
		<>
			<ContactUpdateAttributeDiffCard
				onClick={() => field.onChange({ target: { name, value: "currentContact" } })}
				active={field.value === "currentContact"}
				attribute={row.currentContact}
			/>
			<ContactUpdateAttributeDiffCard
				onClick={() => field.onChange({ target: { name, value: "updatedContact" } })}
				active={field.value === "updatedContact"}
				attribute={row.updatedContact}
			/>
		</>
	);
};
